import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {Touch} from 'vuetify/lib/directives';

import fi from 'vuetify/lib/locale/fi'
import en from 'vuetify/lib/locale/en'
import sv from 'vuetify/lib/locale/sv'

Vue.use(Vuetify, {
  directives: {
    Touch,
  },
});

export default new Vuetify({
  lang: {
    locales: {fi, en, sv},
    current: 'en',
  },
  theme: {
    options: {
      customProperties: true,
    },
    dark: true,
    themes: {
      light: {
        primary: '#D30A10',
        secondary: '#990000',
        accent: '#FF533B',
        error: '#F4511E',
        warning: '#ff9800',
        info: '#40c4ff',
        success: '#66bb6a',
        background: '#ffffff',
      },
      dark: {
        primary: '#D30A10',
        secondary: '#990000',
        accent: '#FF533B',
        error: '#F4511E',
        warning: '#ff9800',
        info: '#40c4ff',
        success: '#66bb6a',
        background: '#242323',
      },
    },
  },
});
